import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface ICapacityTypeCargoCharacteristicAttributes extends IModelAttributes {
	capacityTypeId: string;
	cargoCharacteristicId: string;

	capacityType: Models.CapacityTypeEntity | Models.ICapacityTypeEntityAttributes;
	cargoCharacteristic: Models.CargoCharacteristicEntity | Models.ICargoCharacteristicEntityAttributes;
}

@entity('CapacityTypeCargoCharacteristic')
export default class CapacityTypeCargoCharacteristic
	extends Model
	implements ICapacityTypeCargoCharacteristicAttributes
{
	@observable
	@attribute()
	public capacityTypeId: string;

	@observable
	@attribute()
	public cargoCharacteristicId: string;

	@observable
	@attribute({ isReference: true })
	public capacityType: Models.CapacityTypeEntity;

	@observable
	@attribute({ isReference: true })
	public cargoCharacteristic: Models.CargoCharacteristicEntity;

	constructor(attributes?: Partial<ICapacityTypeCargoCharacteristicAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.capacityTypeId) {
				this.capacityTypeId = attributes.capacityTypeId;
			}
			if (attributes.cargoCharacteristicId) {
				this.cargoCharacteristicId = attributes.cargoCharacteristicId;
			}

			if (attributes.capacityType) {
				if (attributes.capacityType instanceof Models.CapacityTypeEntity) {
					this.capacityType = attributes.capacityType;
					this.capacityTypeId = attributes.capacityType.id;
				} else {
					this.capacityType = new Models.CapacityTypeEntity(attributes.capacityType);
					this.capacityTypeId = this.capacityType.id;
				}
			} else if (attributes.capacityTypeId !== undefined) {
				this.capacityTypeId = attributes.capacityTypeId;
			}

			if (attributes.cargoCharacteristic) {
				if (attributes.cargoCharacteristic instanceof Models.CargoCharacteristicEntity) {
					this.cargoCharacteristic = attributes.cargoCharacteristic;
					this.cargoCharacteristicId = attributes.cargoCharacteristic.id;
				} else {
					this.cargoCharacteristic = new Models.CargoCharacteristicEntity(attributes.cargoCharacteristic);
					this.cargoCharacteristicId = this.cargoCharacteristic.id;
				}
			} else if (attributes.cargoCharacteristicId !== undefined) {
				this.cargoCharacteristicId = attributes.cargoCharacteristicId;
			}
		}
	}
}
